export const FAIT_ASSETS = [
  {
    asset_id: "cny",
    symbol: "CNY",
    name: "CNY",
    precision: 2,
    logo: require("@/assets/images/icon_cny.png")
  }
];

export const USDT_ASSET_ID = "4d8c508b-91c5-375b-92b0-ee702ed2dac5";

export const USDT_ICON =
  "https://mixin-images.zeromesh.net/ndNBEpObYs7450U08oAOMnSEPzN66SL8Mh-f2pPWBDeWaKbXTPUIdrZph7yj8Z93Rl8uZ16m7Qjz-E-9JFKSsJ-F=s128";

export const USDT_META = {
  label: "ERC20",
  select_symbol: "USDT",
  symbol: "USDT (ERC20)",
  alia: "USDT",
  name: "Tether USD (ERC20)",
  chain_id: "43d61dcd-e413-450d-80b8-101d5e903357",
  icon: USDT_ICON,
  logo: USDT_ICON
};

export const USDTO_ASSET_ID = "815b0b1a-2764-3736-8faa-42d694fa620a";

export const USDTO_META = {
  label: "Omni",
  select_symbol: "USDT",
  symbol: "USDT (Omni)",
  alia: "USDTO",
  name: "Tether USD (Omni)",
  chain_id: "c6d0c728-2624-429b-8e0d-d9d19b6592fa",
  icon: USDT_ICON,
  logo: USDT_ICON
};

export const USDTT_ASSET_ID = "b91e18ff-a9ae-3dc7-8679-e935d9a4b34b";

export const USDTT_META = {
  label: "TRC20",
  select_symbol: "USDT",
  symbol: "USDT (TRC20)",
  alia: "USDTT",
  name: "Tether USD (TRC20)",
  chain_id: "25dabac5-056a-48ff-b9f9-f67395dc407c",
  icon: USDT_ICON,
  logo: USDT_ICON
};

export const OTC_HELP_PATH =
  "https://mixin.one/codes/3952ed40-ec20-4f8d-a651-7b4e030957be";

export const AUTO_TRADE_INSTRUCTION = "https://w3c.group/c/1591585216026593";

export const ERROR = {
  HAS_UNPAID_AUTO_TRADE_ORDER: 103009,
  OTC_KYC_ERROR: 108012,
  OTC_USER_NOT_EXIST: 108013
};

export const EXCHANGES = [
  {
    id: "bigone",
    name: "BigONE",
    icon: require("../../assets/images/icon_bigone.png"),
    size: 20
  },
  {
    id: "binance",
    name: "Binance",
    icon: require("../../assets/images/icon_binance.png"),
    size: 20
  },
  {
    id: "mtgswap",
    name: "4swap MTG",
    icon: require("../../assets/images/icon_4swap_mtg.png"),
    size: 20
  },
  {
    id: "efox",
    name: "FoxONE",
    icon: require("../../assets/images/icon_foxone.png"),
    size: 20
  },
  {
    id: "portfolio",
    name: "FoxONE",
    icon: require("../../assets/images/icon_foxone.png"),
    size: 20
  }
];
